module.exports = __webpack_public_path__ + "img/66AC63C1803A2A63.2fc851b0.jpg";